export const formatScoreOverHundred = (value, { withSuffix = true } = {}) => {
	const numericValue = Number(value);

	if (!Number.isFinite(numericValue)) {
		return withSuffix ? "-/100" : "-";
	}

	const normalizedValue =
		Math.abs(numericValue) <= 1 ? numericValue * 100 : numericValue;

	const formattedValue = Number.isInteger(normalizedValue)
		? String(normalizedValue)
		: normalizedValue.toFixed(2).replace(/\.?0+$/, "");

	return withSuffix ? `${formattedValue}/100` : formattedValue;
};

export const formatDateTimeEs = (value, { includeTime = true } = {}) => {
	if (!value) return "-";

	if (typeof value === "string") {
		const match = value
			.trim()
			.match(
				/^(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{2}):(\d{2})(?::(\d{2}))?)?$/
			);

		if (match) {
			const [, year, month, day, hour = "00", minute = "00"] = match;
			const hasTime = Boolean(match[4]);
			return includeTime && hasTime
				? `${day}/${month}/${year} ${hour}:${minute}`
				: `${day}/${month}/${year}`;
		}
	}

	const date = new Date(value);
	if (Number.isNaN(date.getTime())) return String(value);

	const baseOptions = {
		year: "numeric",
		month: "2-digit",
		day: "2-digit",
	};

	return includeTime
		? date.toLocaleString("es-ES", {
				...baseOptions,
				hour: "2-digit",
				minute: "2-digit",
		  })
		: date.toLocaleDateString("es-ES", baseOptions);
};
